import { ref, onMounted, watch } from '@vue/composition-api'

import draggable from 'vuedraggable'

import {
 popupsArr, popupsArr2, popupsArr3, popupsErr, popupsErr2, task1, task2, billet, arrBlocks,
} from './arrs'
import { pushPopup } from '@/utils/pushPopup'

// sortable-chosen sortable-ghost

export default {
  name: 'step1',

  components: {
    draggable,
  },

  setup(_, ctx) {
    const { emit } = ctx
    const paths = ref([])
    const popups = ref([])
    const task = ref(task1)
    const drag = ref(false) // пока не понял зачем он тут нужен

    const step = ref({
      paths: false,
      artistPlate: false,
    })

    const active = ref(false) // активность клика по свг и плашкам

    const myArray = ref(billet)

    const arrMusic = ref([...arrBlocks[0].sort(() => Math.random() - 0.5), ...arrBlocks[1].sort(() => Math.random() - 0.5)])


    const game = {
      currentCoords: [], // текущие координаты точек по которым кликнули
      currentCircles: [], // запоминаем текущие точки (пару)
      finishArrBoolean: [], // финальный массив булеан значений по которым проверяем верный ли итог
      currentErrClick: null, // колличество неверных соотношений пар цирклов

      init(atr) {
        const circles = document.querySelectorAll(`.board > ${atr}`)
        circles.forEach((e) => {
          e.addEventListener('click', () => {
            const coord = { cx: e.cx.baseVal.value, cy: e.cy.baseVal.value, executor: e.attributes.executor.value }

            if (this.currentCoords.length) {
              if (this.checkRow(e)) return
            }

            if (!e.classList.contains('activeCircle')) {
              this.currentCircles.push(e)
            }
            this.addActiveClassOnDote(e) // добавляем активный класс на кружочки

            if (this.checkPath({ ...coord })) return

            this.currentCoords.push({ ...coord })

            if (!this.validCurrenPath()) return // валидируем конкретную пару по патчам

            if (this.currentCoords.length === 2) {
              this.pushFinish()
              this.pushPath()
              this.clearCurrentCoords()
            }

            if (this.currentCircles.length === 2) {
              this.clearArrCurrentCircles()
            }

            if (this.finishArrBoolean.length === 4) {
              this.nextStep(this.validFinish())
            }
          })
        })
      },

      // чистим классы в currentCircles (текущие точки)
      clearClassCurrentCircles() {
        this.currentCircles.forEach((e) => {
          e.classList.remove('activeCircle')
        })
      },

      // чистим массив
      clearArrCurrentCircles() {
        this.currentCircles = []
      },

      // валидируем конкретную соединений патчей
      validCurrenPath() {
        if (this.currentCoords.length === 2) {
          if (this.currentCoords[0].executor !== this.currentCoords[1].executor) {
            this.currentCoords = []
            this.clearClassCurrentCircles()
            this.clearArrCurrentCircles()
            this.currentErrClick += 1
            if (this.currentErrClick === 3) {
              pushPopup(popupsErr2, popups.value)
              this.currentErrClick = null
            }
            return false
          }
        }
        return true
      },

      // полная очистка
      fullCleaning() {
        paths.value = []
        this.finishArrBoolean = []
        this.fullClearActiveClassOnDote()
      },

      // след шаг внутри этого степа
      nextStep(bool) {
        active.value = false
        if (bool) {
          pushPopup(popupsArr2, popups.value)
          step.value.paths = true
          task.value = task2
        } else {
          pushPopup(popupsErr, popups.value)
          this.fullCleaning()
        }
      },

      // очистка текущей координаты(a, b)
      clearCurrentCoords() {
        this.currentCoords = []
      },

      // проверка соотношений пар
      validFinish() {
        return this.finishArrBoolean.every(Boolean)
      },

      // пушим в массив финиша
      pushFinish() {
        const [doteA, doteB] = this.currentCoords
        this.finishArrBoolean.push(doteA.executor === doteB.executor)
      },

      // проверка на совпадение линий(от точки а до б)
      checkPath(coord) {
        const cxy = `${coord.cx} ${coord.cy}`
        return paths.value.find(e => e.doteA.includes(cxy) || e.doteB.includes(cxy))
      },

      // пушим координаты линий
      pushPath() {
        // M984 179L414 285 (doteA:(x=M984 y=179) doteB:(x=414 y=285) ) расшифровка
        const [doteA, doteB] = this.currentCoords
        const dotesP = { doteA: `${doteA.cx} ${doteA.cy}`, doteB: `${doteB.cx} ${doteB.cy}` }

        paths.value.push({
          d: `M${doteA.cx} ${doteA.cy}L${doteB.cx} ${doteB.cy}`,
         ...dotesP,
        })
      },

      // проверка на клик ряда
      checkRow(d) {
        return this.currentCoords[0].cy === d.cy.baseVal.value
      },

      // добавляет активный класс на дот
      addActiveClassOnDote(d) {
        if (!d.classList.contains('activeCircle')) {
          d.classList.add('activeCircle')
        }
      },

      // очищает класс на дот
      fullClearActiveClassOnDote() {
        const circles = document.querySelectorAll('.board > circle')
        circles.forEach((e) => { e.classList.remove('activeCircle') })
      },
    }

    onMounted(() => {
      game.init('circle')
    })

    // не позволяет повторно закидывать плашки
    const validDouble = () => {
      const newArr = arrMusic.value.filter(e => e.arr.length)
      newArr.forEach((e) => {
        if (e.arr[1]) {
          myArray.value.push(e.arr[1])
          e.arr.splice(1, 1)
        }
      })
    }

    // пушим парные блоки муз авторов
    watch(arrMusic.value, () => {
      validDouble()
      // const filledArr = arrMusic.value.filter(e => e.arr.length)
      // let arrIndex = null
      // filledArr.forEach((e) => {
      //   arrIndex = arrMusic.value.map((item, index) => (item.key.includes(e.key) && index)).filter(Boolean) // достаем индексы совпадений
      //   arrIndex.forEach((numIndex) => {
      //     if (!arrMusic.value[numIndex].arr.length) arrMusic.value[numIndex].arr.push(e.arr[0])
      //   })
      // })
    })

    // валидация для плашек авторов, соотношение рекомендаций
    const validPlate = () => {
      const clear = (data) => {
        data.forEach((e) => {
          e.arr = []
          myArray.value = billet
        })
      }

      if (!myArray.value.length) {
        const arrMusicProxy = arrMusic.value.filter(e => e.arr.length) // получаем массив где присутствуют плашки авторов
        const valid = arrMusicProxy.every(e => e.key === e.arr[0].key || e.key === e.arr[0].key2)
        active.value = false
        if (!valid) {
          clear(arrMusicProxy)
          pushPopup(popupsErr, popups.value)
        } else {
          pushPopup(popupsArr3, popups.value)
          step.value.artistPlate = true
        }
      }
    }

    const init = () => {
     pushPopup(popupsArr, popups.value)
    }

    init()

    // проверка для перехода на след урок
    const validNextLesson = () => {
      const arrValid = []
      // eslint-disable-next-line
      for (const key in step.value) {
        arrValid.push(step.value[key])
      }
      if (arrValid.every(Boolean)) emit('nextStep', 2)
    }

    const nextStep = () => {
      popups.value = []
      active.value = true
      validNextLesson()
    }

    return {
      step,
      drag,
      arrMusic,
      myArray,
      paths,
      popups,
      active,
      task,
      arrBlocks,
      validPlate,
      nextStep,
    }
  },
}
